import { ActionIcon, Portal } from "@mantine/core";
import { useHotkeys } from "@mantine/hooks";
import { X } from "lucide-react";
import type { ReactNode } from "react";

import { AudioPlayer } from "../../ui/AudioPlayer";
import classes from "./sounds.module.css";

export interface MiniPlayerProps {
  url: string;
  name: string;
  durationSeconds: number | null;
  onClose: () => void;
  /** The file's link no longer loads: read the list again for a fresh one. */
  onError: () => void;
  /** A generation's own actions beside the player (live's `SoundPreviewDialog` `actions`). */
  actions?: ReactNode;
}

/**
 * Live's mini player (capture 07): pinned at the top centre over the page, 730px wide, it plays
 * the chosen sound at once; × or Escape closes it. Not a dialog: the page stays usable under it.
 * A generation's sound carries its Save and Download beside the player, as live's preview does.
 */
export function MiniPlayer(props: MiniPlayerProps) {
  const { url, name, durationSeconds, onClose, onError, actions } = props;
  useHotkeys([["Escape", onClose]]);
  return (
    <Portal>
      <section className={classes.miniPlayer} aria-label="Now playing">
        <AudioPlayer
          url={url}
          name={name}
          autoPlay
          durationSeconds={durationSeconds}
          onError={onError}
        />
        {actions}
        <ActionIcon variant="text" aria-label="Close the player" onClick={onClose}>
          <X size={20} />
        </ActionIcon>
      </section>
    </Portal>
  );
}
